import React from 'react';
import cx from 'clsx';

import styles from './CouponCard.module.css';

type Props = {
  badgeSection: React.ReactNode;
  title: string;
  description: string;
  helpText: string;
  suffix?: React.ReactNode;
  prefix?: React.ReactNode;
  notice: string[];
  disabled?: boolean;
  selected?: boolean;
  onClick?(): void;
};
function CouponCard({
  badgeSection,
  title,
  description,
  helpText,
  suffix,
  prefix,
  notice,
  disabled,
  selected,
  onClick,
}: Props) {
  const [isMoreView, setIsMoreView] = React.useState(false);

  return (
    <div
      role="presentation"
      className={cx('w-full h-[172px]', {
        'pointer-events-none': disabled,
        '[&>div]:border-primary-regular': selected,
        [styles.more]: isMoreView,
      })}
      onClick={onClick}
    >
      <div
        className={cx(
          'relative w-full h-full border border-screen-02 rounded-16',
          styles.inner,
        )}
      >
        <div
          className={cx(
            'absolute left-0 w-full h-full p-16 flex flex-col',
            styles.back,
          )}
        >
          <ul className="flex-1 overflow-auto">
            {notice.map((v, index) => (
              <li
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className="relative ml-16 list-disc typo-footnote300-regular"
              >
                {v}
              </li>
            ))}
          </ul>
          <div>
            <button
              type="button"
              className="text-icon underline typo-footnote300-regular"
              onClick={(e) => {
                e.stopPropagation();
                setIsMoreView((prev) => !prev);
              }}
            >
              쿠폰보기
            </button>
          </div>
        </div>
        <div
          className={cx(
            'absolute left-0 w-full h-full p-16 flex flex-row items-center',
            styles.front,
          )}
        >
          {prefix && <div>{prefix}</div>}
          <div className="ml-16 flex grow flex-col overflow-hidden first-of-type:ml-0">
            <div className={cx(disabled && 'opacity-50')}>{badgeSection}</div>
            <div className={cx(disabled && '[&_*]:!text-disabled')}>
              <div className="flex-1 overflow-auto">
                <h3 className="text-paragraph typo-heading200">{title}</h3>
                <p className="mb-6 truncate text-paragraph typo-paragraph100-regular">
                  {description}
                </p>
                <p className="mb-16 text-hint typo-footnote300-regular">
                  {helpText}
                </p>
              </div>
              <button
                type="button"
                className="text-icon underline typo-footnote300-regular"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMoreView((prev) => !prev);
                }}
              >
                상세조건 보기
              </button>
            </div>
          </div>
          {suffix && <div className="cursor-pointer">{suffix}</div>}
        </div>
      </div>
    </div>
  );
}

export default CouponCard;
